module.exports = __webpack_public_path__ + "static/media/bread-18987_1280.2213e743.jpg";